import React from 'react';

import Box, { BoxProps } from 'carbon-react/lib/components/box';

export const SfaFormIndentation = ({ children, ...props }: BoxProps) => {
  return (
    <Box {...props} display="flex" position="relative">
      <Box width="2px" mr={2}>
        <Box height="100%" width="100%" backgroundColor="--colorsUtilityMajor100" />
      </Box>
      <Box width="100%">{children}</Box>
    </Box>
  );
};
